module.exports = __webpack_public_path__ + "img/hk_hhk.0ae7ea47.png";